import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import qs from 'qs';
import config from '../../config';
import { ERROR_CODE_ZH } from '../../constants/login';
import { unBindWx, wxOauthBindWx } from '../../service/login';
import { useConfirmWarning } from '../../utils/antd-confirm';
import { useMsgFail, useMsgSuccess } from '../../utils/antd-message';
import { getDefaultAvartar, getWxRedirectUrl, wrapAvartarUrl } from '../../utils/common';
import { autoRefreshToken, closeAutoRefreshToken } from '../../utils/login';
import { ChangePhone } from '../change-phone';
import { PerfectData } from '../perfect-data';
import { RESET_TYPE, ResetPassword } from '../reset-password';
import './index.less';
import { useStatistics } from '../../utils/statistics';
export function PersonalData(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    currentAccount = _ref.currentAccount,
    tenantName = _ref.tenantName,
    _ref$showPerfectData = _ref.showPerfectData,
    showPerfectData = _ref$showPerfectData === void 0 ? true : _ref$showPerfectData,
    onUnBindSuccess = _ref.onUnBindSuccess,
    onPerfectDataSuccess = _ref.onPerfectDataSuccess,
    onChangePhoneSuccess = _ref.onChangePhoneSuccess,
    onResetPasswordSuccess = _ref.onResetPasswordSuccess,
    onWxBindSuccess = _ref.onWxBindSuccess;
  useStatistics('PersonalData');
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    curOpen = _useState2[0],
    setCurOpen = _useState2[1];
  var wrapRef = useRef(null);
  var ConfirmWarning = useConfirmWarning();
  var MsgSuccess = useMsgSuccess();
  var MsgFail = useMsgFail();
  var handleBindWx = useCallback(function () {
    if (currentAccount.wxBound) {
      ConfirmWarning({
        title: '确定解绑微信账号？',
        content: '解绑后将无法使用微信扫码登录。',
        onOk: function () {
          var _onOk = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
            var _yield$unBindWx, _yield$unBindWx$data, code, message;
            return _regeneratorRuntime().wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return unBindWx();
                case 3:
                  _yield$unBindWx = _context.sent;
                  _yield$unBindWx$data = _yield$unBindWx.data;
                  code = _yield$unBindWx$data.code;
                  message = _yield$unBindWx$data.message;
                  if (code === '0') {
                    MsgSuccess('解绑成功');
                    onUnBindSuccess && onUnBindSuccess();
                  } else {
                    MsgFail(message);
                  }
                  _context.next = 14;
                  break;
                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](0);
                  console.warn(_context.t0);
                  MsgFail('解绑失败');
                case 14:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 10]]);
          }));
          function onOk() {
            return _onOk.apply(this, arguments);
          }
          return onOk;
        }(),
        onCancel: function onCancel() {
          console.log('Cancel');
        }
      });
    }
  }, [ConfirmWarning, MsgFail, MsgSuccess, currentAccount.wxBound, onUnBindSuccess]);
  var rowInners = useMemo(function () {
    var inners = showPerfectData ? [/*#__PURE__*/React.createElement(PerfectData, {
      currentAccount: currentAccount,
      active: curOpen === 0,
      tenantName: tenantName,
      isIndependent: false,
      onSuccess: onPerfectDataSuccess
    })] : [];
    return [].concat(inners, [/*#__PURE__*/React.createElement(ChangePhone, {
      style: {
        width: '640px',
        marginLeft: '96px'
      },
      active: curOpen === 1,
      userPhone: currentAccount.phone,
      onSuccess: onChangePhoneSuccess
    }), /*#__PURE__*/React.createElement(ResetPassword, {
      style: {
        width: '640px',
        marginLeft: '96px'
      },
      onSuccess: onResetPasswordSuccess,
      active: curOpen === 2,
      userPhone: currentAccount.phone,
      type: RESET_TYPE.UPDATE
    }), /*#__PURE__*/React.createElement("div", {
      id: "login_container",
      style: {
        marginLeft: '35px'
      }
    })]);
  }, [showPerfectData, currentAccount, curOpen, tenantName, onPerfectDataSuccess, onChangePhoneSuccess, onResetPasswordSuccess]);
  var rowInnerHeights = useMemo(function () {
    var heights = showPerfectData ? ['360px'] : [];
    return [].concat(heights, ['520px', '520px', '268px']);
  }, [showPerfectData]);
  var rowConfigs = useMemo(function () {
    var configs = showPerfectData ? [{
      label: '个人信息',
      vlaue: /*#__PURE__*/React.createElement("div", {
        className: "login-personal-data-info-wrap"
      }, /*#__PURE__*/React.createElement("img", {
        className: "login-personal-data-info-avartar",
        src: currentAccount.avatar ? wrapAvartarUrl(currentAccount.avatar) : getDefaultAvartar(),
        alt: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: "login-personal-data-info"
      }, /*#__PURE__*/React.createElement("div", {
        className: "login-personal-data-info-name fontBold"
      }, currentAccount.nickname || "\u5C3E\u53F7".concat(currentAccount.phone.slice(-4))), tenantName && /*#__PURE__*/React.createElement("div", {
        className: "login-personal-data-info-school"
      }, tenantName))),
      isWxBind: false
    }] : [];
    return [].concat(configs, [{
      label: '账号管理',
      vlaue: currentAccount.phone,
      isWxBind: false
    }, {
      label: '登录密码',
      vlaue: currentAccount.hasPassword ? '已设置' : '未设置',
      isWxBind: false
    }, {
      label: '微信账号',
      vlaue: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, currentAccount.wxBound ? currentAccount.wxNickName || '未能拿到您的昵称哦' : '未绑定'), /*#__PURE__*/React.createElement("span", {
        className: "login-personal-data-bindwx-btn",
        onClick: handleBindWx
      }, currentAccount.wxBound ? '解绑' : '绑定微信')),
      isWxBind: true
    }]);
  }, [showPerfectData, currentAccount.avatar, currentAccount.nickname, currentAccount.phone, currentAccount.hasPassword, currentAccount.wxBound, currentAccount.wxNickName, tenantName, handleBindWx]);
  var onClickRow = function onClickRow(index) {
    if (currentAccount.wxBound) {
      if (index !== rowConfigs.length - 1) {
        setCurOpen(curOpen === index ? -1 : index);
      }
    } else {
      setCurOpen(curOpen === index ? -1 : index);
    }
  };
  var judgeWxRedirect = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var search, param, _yield$wxOauthBindWx, _yield$wxOauthBindWx$, code, message;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!currentAccount) {
            _context2.next = 23;
            break;
          }
          search = window.location.search.slice(1);
          param = qs.parse(search);
          window.history.replaceState({}, '', "".concat(window.location.origin).concat(window.location.pathname).concat(window.location.hash));
          _context2.prev = 4;
          if (!search) {
            _context2.next = 17;
            break;
          }
          if (!(param.appId && param.code)) {
            _context2.next = 17;
            break;
          }
          if (!currentAccount.wxBound) {
            _context2.next = 10;
            break;
          }
          MsgFail('绑定失败，该账号已绑定其他微信');
          return _context2.abrupt("return");
        case 10:
          _context2.next = 12;
          return wxOauthBindWx({
            oauthRequest: {
              appId: param.appId,
              code: param.code
            },
            csrfToken: param.csrfToken
          });
        case 12:
          _yield$wxOauthBindWx = _context2.sent;
          _yield$wxOauthBindWx$ = _yield$wxOauthBindWx.data;
          code = _yield$wxOauthBindWx$.code;
          message = _yield$wxOauthBindWx$.message;
          if (code === '0') {
            onWxBindSuccess();
          } else {
            MsgFail(ERROR_CODE_ZH[code] || message || '绑定微信失败');
          }
        case 17:
          _context2.next = 23;
          break;
        case 19:
          _context2.prev = 19;
          _context2.t0 = _context2["catch"](4);
          if (search && param.appId && param.code) {
            MsgFail('绑定微信失败');
          }
          console.warn(_context2.t0);
        case 23:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[4, 19]]);
  })), [MsgFail, currentAccount, onWxBindSuccess]);
  useEffect(function () {
    if (!currentAccount.wxBound) {
      var publicPath = window.location.origin + window.location.pathname;
      if (publicPath.endsWith('index.html')) {
        publicPath = publicPath.slice(0, publicPath.lastIndexOf('index.html'));
      }
      // @ts-ignore
      // eslint-disable-next-line
      var obj = new WxLogin({
        self_redirect: false,
        id: 'login_container',
        appid: config.WX_SCAN_APPID,
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent("".concat(config.WX_SCAN_REDIRECT_URL, "?redirectUrl=").concat(encodeURIComponent(getWxRedirectUrl()))),
        state: '',
        style: '',
        href: "".concat(encodeURIComponent(publicPath), "wx-scan.css")
      });
    }
  }, [currentAccount.wxBound]);
  useEffect(function () {
    judgeWxRedirect();
  }, [judgeWxRedirect]);
  useEffect(function () {
    autoRefreshToken();
    return function () {
      closeAutoRefreshToken();
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    onClick: onClick,
    className: "".concat(className, " login-personal-data"),
    ref: wrapRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-personal-data-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: "login-personal-data-content"
  }, rowConfigs.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "login-personal-data-row ".concat(item.isWxBind ? 'login-personal-data-bindwx' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-personal-data-row-header",
      onClick: function onClick() {
        return onClickRow(index);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-personal-data-label fontBold"
    }, item.label), /*#__PURE__*/React.createElement("div", {
      className: "login-personal-data-value ".concat(curOpen === index ? 'active' : '')
    }, curOpen === index ? null : item.vlaue)), /*#__PURE__*/React.createElement("div", {
      className: "login-personal-data-row-body",
      style: {
        height: curOpen === index ? rowInnerHeights[index] : '0'
      }
    }, rowInners[index] || null));
  }))));
}